// removed by extract-text-webpack-plugin
module.exports = {"companyCell":"_2cI_nvW60ZPbMTKauNWx3m","logo":"_1DdkdMkNPxKRbE1Y3KmkaN","infoBlock":"_3lnNHTnMl97C12DWeCl4rM","companyName":"_10wa15Je-6vXjloPuy0Ibp","bottomBlock":"_2ytwUFd3RO7tVoK7zDx-ZZ","propertiesWrapper":"nsFiSWbUXiUUcxGyPjDgg","count":"_2PH3f_to_H3yDbIhnV_tNs","text":"_1aecirv-XFrV-wrZhd2dw_","buttonWrapper":"_1iL5C98Q3jvLLY502FoKCS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/СompanyСard/CompanyCard.scss
// module id = 1772
// module chunks = 0